export function getCookie(cookieName: string) {
	const name = cookieName + '=';
	const decodedCookie = decodeURIComponent(document.cookie);
	const ca = decodedCookie.split(';');
	for (let c of ca) {
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
}

export function setCookie(name: string, value: string, days: number, path?: string, domain?: string) {
	let expires = '';
	if (days) {
		const date = new Date();
		date.setDate(date.getDate() + days);
		expires = '; expires=' + date.toUTCString();
	}
	document.cookie =
		name +
		'=' +
		encodeURIComponent(value || '') +
		'; ' +
		expires +
		'; path=' +
		(path || '/') +
		'; domain=' +
		domain +
		';';
}

export function setGoogleAnalyticsCookies() {
	const consentMode = {
		analytics_storage: 'granted',
		ad_storage: 'granted',
		personalization_storage: 'granted',
		functionality_storage: 'granted',
		security_storage: 'granted',
	};

	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	gtag('consent', 'update', consentMode);
	localStorage.setItem('consentMode', JSON.stringify(consentMode));
}

function gtag() {
	// eslint-disable-next-line prefer-rest-params
	window.dataLayer.push(arguments);
}

export function checkCookie(cookieName: string) {
	const cookie = getCookie(cookieName);
	return cookie !== '';
}
